module.exports = __webpack_public_path__ + "img/114.10.80193633.png";